<template>
  <v-app id="inspire">
    <!-- Start of where the actual pages go -->
    <v-content>
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </v-content>
    <!-- End of where the actual pages go -->
  </v-app>
</template>

<script>

  export default {
    name: 'App',
    data: () => ({
      //
    }),
    props: {
      source: String
    },
    computed: {
      route: function (){
        return this.$route
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  .slide-fade-enter-active {
    transition: all .3s ease;
  }
  .slidefade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
  }

</style>